
namespace Gamification.Gamification {
    export class ProdottiClassiColumns {
        static columnsKey = 'Gamification.ProdottiClassi';
    }
}